export const fechaLarga = (iso) => {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  return isNaN(d) ? iso : d.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
};
